import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-main-footer',
  imports: [RouterLink, TranslateModule],
  templateUrl: './main-footer.component.html',
  styleUrl: './main-footer.component.css',
})
export class MainFooterComponent {
  private authService = inject(AuthService);
  readonly isLoggedIn = this.authService.isCustomerLoggedIn;

  flight!: any;

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
